import store from '../store';

export default {
    data() {
        return {
            loadingOrderSummary: false,
            shippingMethodName: null,
            applyingCoupon: false,
            couponCode: null,
            couponError: null,
            cartRequestSeq: 0,
        };
    },

    computed: {
        cart() {
            return store.state.cart;
        },

        cartIsEmpty() {
            return store.cartIsEmpty();
        },

        cartIsNotEmpty() {
            return ! store.cartIsEmpty();
        },

        hasShippingMethod() {
            return store.hasShippingMethod();
        },

        firstShippingMethod() {
            return Object.keys(store.state.cart.availableShippingMethods)[0];
        },

        hasCoupon() {
            return store.state.cart.coupon.code !== undefined;
        },
    },

    methods: {
        /**
         * Calculate the effective max quantity for a product.
         * Returns min(stock, max_order_qty) when both constraints apply,
         * or just the stock value if max_order_qty is not set.
         */
        effectiveMaxQty(product) {
            const limits = [];

            if (product.manage_stock && product.qty !== null && product.qty !== undefined) {
                limits.push(product.qty);
            }

            if (product.max_order_qty !== null && product.max_order_qty !== undefined) {
                limits.push(product.max_order_qty);
            }

            return limits.length > 0 ? Math.min(...limits) : null;
        },

        applyCoupon() {
            if (! this.couponCode) {
                return;
            }
            this.couponError = '';
            this.loadingOrderSummary = true;
            this.applyingCoupon = true;

            $.ajax({
                method: 'POST',
                url: route('cart.coupon.store', { coupon: this.couponCode }),
            }).then((cart) => {
                this.couponCode = null;

                store.updateCart(cart);
            }).catch((xhr) => {
                this.couponError = xhr.responseJSON.message;
            }).always(() => {
                this.loadingOrderSummary = false;
                this.applyingCoupon = false;
            });
        },

        removeCoupon() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'DELETE',
                url: route('cart.coupon.destroy'),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        getRates(trigger) {
            this.loadingOrderSummary = true;
            this.form.cartItems = this.cart.items;

            const requestSeq = ++this.cartRequestSeq;

            $.ajax({
                method: 'POST',
                url: route('cart.shipping.rates'),
                data: this.form,
            }).then((cart) => {
                if (requestSeq !== this.cartRequestSeq) {
                    return;
                }

                store.updateCart(cart);
                if (trigger === 'taxAdded') {
                    this.changeShippingMethod(this.cart.shippingMethodName);
                } else {
                    this.updateShippingMethod(this.cart.shippingMethodName);
                }
            }).catch((xhr) => {
                if (requestSeq !== this.cartRequestSeq) {
                    return;
                }

                this.$notify(xhr.responseJSON.message);
                this.cart.availableShippingMethods = {};
            }).always(() => {
                if (requestSeq === this.cartRequestSeq) {
                    this.loadingOrderSummary = false;
                }
            });
        },

        updateShippingMethod(shippingMethod) {
            if (typeof shippingMethod === 'string') {
                shippingMethod = { name: shippingMethod };
            } else {
                this.loadingOrderSummary = true;
            }

            this.changeShippingMethod(shippingMethod);

            $.ajax({
                method: 'POST',
                url: route('cart.shipping_method.store', { shipping_method: shippingMethod.name }),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },
    },
};
